module.exports = __webpack_public_path__ + "media/images/emblems/Vaux-sur-Morges-coat_of_arms-06623b5924b519143ad576c5daa652c0.svg";